import styled from "styled-components"
export const UnderTitle = styled.h2`
font-size:50px;
color:blueviolet;
font-style:italic;
font-weight:900;
 text-align:center;
 margin-bottom:25px;
 margin-top:25px;
`